import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaUserCircle } from 'react-icons/fa';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { FormProvider } from '@tq/ui-components/dist/components/forms-engine';
import {
  AttentionMessage,
  Button,
  Grid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@tq/ui-components';
import { UploadConsulteesResponse } from 'api';

type UploadConsulteesSummaryModalProps = {
  isOpen: boolean;
  uploadResponse?: UploadConsulteesResponse;
  onClose: () => void;
};

export const UploadConsulteesSummaryModal: React.FC<UploadConsulteesSummaryModalProps> = ({
  isOpen,
  uploadResponse,
  onClose,
}) => {
  const { t } = useTranslation('uploadconsuteessummary_modal');

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCancel}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader aria-label={t('assign_modal', 'Upload summary')}>
          <Grid gridAutoFlow='column' gridGap={4}>
            <FaUserCircle color={COLOURS.blue[600]} />
            <span>{t('assign_header', 'Upload Summary')}</span>
          </Grid>
          <ModalCloseButton />
        </ModalHeader>
        <ModalBody overflow='visible'>
          <FormProvider>
            {uploadResponse && (
              <div>
                <AttentionMessage
                  title={`Successfully uploaded records:  ${uploadResponse.success}`}
                  status='success'
                  variant='inline'
                  mt={8}
                />
                {uploadResponse.fail !== 0 && (
                  <div>
                    <AttentionMessage
                      title={`Failed uploaded records:  ${uploadResponse.fail}`}
                      status='error'
                      variant='inline'
                      mt={8}
                    />
                    <div style={{ overflow: 'auto', maxHeight: '200px', fontSize: '12px' }}>
                      {uploadResponse?.details?.map((detail, index) => {
                        return (
                          <li key={index} style={{ listStyle: 'none', paddingLeft: '48px' }}>
                            <b>{`${t('row', 'Row')} # ${detail.row}`}</b> -
                            <b> {`${t('failure_reason', 'Failure Reason:')}`}</b>
                            {`${detail.message}`}
                          </li>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}
          </FormProvider>
        </ModalBody>
        <ModalFooter justifyContent='end'>
          <Grid gridAutoFlow='column' gridGap={4}></Grid>
          <Button onClick={handleCancel}>{t('cancel_button_text', 'Close')}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
